var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('j-search-select-tag',{attrs:{"placeholder":_vm.placeholder,"value":_vm.value,"dictOptions":_vm.searchOptions},on:{"change":_vm.onChange}})}
var staticRenderFns = []

export { render, staticRenderFns }